import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router/router"
import veeValidatePlugin from "@/plugins/veeValidatePlugin";
import uiPlugin from "@/plugins/uiPlugin";
import i18n from "@/plugins/i18n";
import store from "./store";
import dayJs from "@/helpers/dayjs";
import firebaseApp from "@/firebase/firebase";
import {
    checkMessagingSupport,
    requestForToken,
    onMessageListener
} from "./firebase/messaging";
import notificationApi from "@/apis/Notification.api";

Vue.config.productionTip = false

veeValidatePlugin.register();
uiPlugin.register();

const app = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount("#app")

//Đăng ký Service Worker sau khi Vue khởi tạo
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register(process.env.NODE_ENV === "development" ? "/firebase-messaging-sw.js" : "/dashboard/firebase-messaging-sw.js")
            .then(registration => {
                console.log("Đăng ký Service Worker thành công:", registration);
            })
            .catch(err => {
                console.error("Lỗi long ký Service Worker:", err);
            });
    });
}

checkMessagingSupport().then(supported => {
    if (!supported) {
        console.warn("Trình duyệt không hỗ trợ Firebase Messaging (ví dụ Safari iOS)");
        return;
    }

    requestForToken().then(async token => {
        if (token) {
            // Gửi token về server nếu cần
            console.log("Token người dùng:", token);
            let idDevice = window.localStorage.getItem("device_id");
            const response = await notificationApi.AddFcmDevice({fcmToken: token, idDevice: idDevice});

            if (response.error) console.log(response.message);
        }
    });

    onMessageListener().then(payload => {
        console.log("Thông báo foreground:", payload);

        // Gợi ý: bạn có thể dùng toast hoặc alert
        alert(`${ payload.notification?.title }\n${ payload.notification?.body }`);
    });
});

Vue.prototype.$dayJs = dayJs;
Vue.prototype.$isK12 = () => store.getters["app/isK12"];
Vue.prototype.$isUniversity = () => store.getters["app/isUniversity"];
Vue.prototype.$isK12OrBusiness = () => store.getters["app/isK12OrBusiness"];
Vue.prototype.$isMoocs = () => store.getters["app/isMoocs"];
Vue.prototype.$idSite = () => store.getters["app/idSite"];
Vue.prototype.$notificationToken = () => store.getters["auth/notificationToken"];
Vue.prototype.$showManualAttendance = () => store.getters["app/showManualAttendance"];

Vue.directive("click-outside", {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent)
    },
});

export default app;
